<template>
	<layout-admin>
		<div class="w-full h-full relative">
			<!-- Legend -->
			<div class="absolute bg-white right-4 top-4 rounded-lg p-4 z-500 shadow">
				<ui-select
					class="block mb-4"
					v-model="currentGrp"
					:options="grpSelectOptions"
					:allow-empty="false"
				/>

				<div class="flex flex-col gap-y-4 items-start">
					<div
						class="flex gap-x-4 items-center"
						v-for="(bucket, idx) in mapData.buckets"
						:key="'BUCKET_LEGEND_' + idx"
					>
						<div class="inline-block headline rounded-full bg-gray-300 w-8 h-8">
							<div
								class="headline rounded-full bg-red-500 w-8 h-8"
								:style="'opacity:' + idx / 5"
							></div>
						</div>
						<div>{{ bucket.minPrice }} – {{ bucket.maxPrice }} €/t</div>
					</div>
				</div>
			</div>
			<crop-map
				:should-fit-bounds="false"
				style="height: calc(100vh - 56px)"
				ref="map"
			>
				<template v-slot:other>
					<l-marker
						ref="marker"
						v-for="(point, idx) in mapData.points"
						:key="'MARKER_' + idx"
						:lat-lng="fromGeoJson(point.geo)"
					>
						<l-icon :icon-size="[14, 14]">
							<div class="headline rounded-full bg-gray-300 w-4 h-4">
								<div
									class="headline rounded-full bg-red-500 w-4 h-4"
									:style="'opacity:' + point.bucket / 5"
								></div>
								<!-- {{ point.bucket }} -->
							</div>
						</l-icon>
					</l-marker>
				</template>
			</crop-map>
		</div>
	</layout-admin>
</template>

<script>
import {
	map as lodashMap,
	min as lodashMin,
	max as lodashMax,
	uniq,
	chunk as lodashChunk,
	sortBy as lodashSortBy,
} from "lodash";
import { LMarker, LIcon } from "vue2-leaflet";
export default {
	props: {
		priceIndications: {
			type: Array,
			required: true,
		},
	},
	components: {
		LMarker,
		LIcon,
	},
	data() {
		let grpOptions = uniq(lodashMap(this.priceIndications, "_grp")).sort();
		return {
			grpOptions: grpOptions,
			currentGrp: grpOptions[0],
			product: [],
		};
	},
	computed: {
		mapData() {
			const NUMBER_OF_BUCKETS = 5;
			let filteredPoints = this.priceIndications
					.filter((pi) => pi._grp == this.currentGrp)
					.map(function (p) {
						p.price__mt = p.price__mt * 1;
						return p;
					}),
				allPrices = lodashMap(filteredPoints, "price__mt"),
				minPrice = lodashMin(allPrices),
				maxPrice = lodashMax(allPrices),
				chunkedPoints = lodashChunk(
					lodashSortBy(filteredPoints, "price__mt"),
					Math.floor(allPrices.length / NUMBER_OF_BUCKETS)
				),
				buckets = [];

			let points = chunkedPoints.flatMap(function (items, bucket) {
				let pricesInBucket = lodashMap(items, "price__mt");
				buckets[bucket] = {
					minPrice: lodashMin(pricesInBucket),
					maxPrice: lodashMax(pricesInBucket),
				};
				return items.map(function (item) {
					item.bucket = bucket;
					item.gradient =
						(100 * (item.price__mt - minPrice)) / (maxPrice - minPrice);
					return item;
				});
			});

			return {
				points: points,
				buckets: buckets,
			};
		},
		iconUrl() {
			return (
				window.baseUrl + "/images/leaflet-color-markers/img/circle-green.svg"
			);
		},
		grpSelectOptions() {
			return this.grpOptions.map(function (o) {
				return { id: o, name: o };
			});
		},
	},
	methods: {
		fromGeoJson: function (geoJ) {
			return {
				lat: geoJ.coordinates[1],
				lng: geoJ.coordinates[0],
			};
		},
	},
};
</script>
